import { Combobox } from '@components/ui/Combobox';
import { SectionCard } from './SectionCard';
import { SectionRow } from './SectionRow';

interface PreferencesData {
  language: string;
  timezone: string;
}

interface PreferencesSectionProps {
  data: PreferencesData;
  onChange: (field: keyof PreferencesData, value: string) => void;
}

export const PreferencesSection = ({ data, onChange }: PreferencesSectionProps) => {
  return (
    <SectionCard title="Preferences" description="Localization and display.">
      <SectionRow label="Language" htmlFor="preferences-language">
        <Combobox
          id="preferences-language"
          options={[
            { value: 'es', label: 'Español' },
            { value: 'en', label: 'English' },
          ]}
          value={data.language}
          onChange={(e) => onChange('language', e.target.value)}
          className="border-[var(--base-border,#3d3d3d)] bg-[var(--base-surface-1,#141414)] text-[var(--text-dark-primary,#fff)]"
        />
      </SectionRow>

      <SectionRow label="Time zone" htmlFor="preferences-timezone">
        <Combobox
          id="preferences-timezone"
          options={[
            { value: 'bue', label: '(GMT-03:00) Buenos Aires' },
            { value: 'mad', label: '(GMT+01:00) Madrid' },
          ]}
          value={data.timezone}
          onChange={(e) => onChange('timezone', e.target.value)}
          className="border-[var(--base-border,#3d3d3d)] bg-[var(--base-surface-1,#141414)] text-[var(--text-dark-primary,#fff)]"
        />
      </SectionRow>
    </SectionCard>
  );
};
